const DEFAULT_ORIGIN = typeof window !== "undefined" ? window.location.origin : "";

export const APP_API_BASE = process.env.REACT_APP_API_BASE || DEFAULT_ORIGIN;
export const DATA_API_BASE = process.env.REACT_APP_DATA_API_BASE || `${DEFAULT_ORIGIN}/data-api`;
